// import statistic from '@/store/modules/statistic.js'
import {authRequest, plainRequest} from './index.js'

export async function create_report(report){
  let data
  await authRequest.post(
    '/report/upload/' + report.id,
    { report },
    { headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

// export async function update_report(report){
//   let data
//   await authRequest.post(
//     '/report/uploa/' + report.id,
//     { report },
//     { headers: {
//       'Content-Type': 'multipart/form-data'
//     }
//   }
//   )
//   .then(function(result){
//     data = {result, error: false}
//   })
//   .catch(function (error){
//     console.log(error)
//     data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
//   })
//   return data
// }

export async function filterChildren(filterObj){
  let data
  await authRequest.get(
    '/childrens',
    {
      params: filterObj
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function retrieve_report(id){
  let data
  await authRequest.get(
    '/report/' + id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

